import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  PATHWAY_LEAD_TITLE,
  buildPathwayDetailRows,
  getPathwayPreferencesFromLead,
  isPathwayLead,
} from 'lib/pathway-leads';
import Link from 'next/link';

type PathwayLeadDetailsProps = {
  lead: {
    content?: Record<string, any>;
    metadata?: Record<string, any>;
  };
};

export default function PathwayLeadDetails({ lead }: PathwayLeadDetailsProps) {
  if (!isPathwayLead(lead)) {
    return null;
  }

  const preferences = getPathwayPreferencesFromLead(lead);
  const rows = buildPathwayDetailRows(preferences);
  const qualifications =
    preferences?.current_qualifications?.trim() ||
    lead.content?.message?.trim() ||
    '';

  return (
    <div className="sm:col-span-2">
      <dt className="text-sm font-medium text-gray-500 mb-4">
        {PATHWAY_LEAD_TITLE}
      </dt>
      <dd className="mt-1 space-y-4">
        {rows.length > 0 ? (
          <div className="rounded-lg border border-indigo-200 bg-indigo-50 p-4">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {rows.map((row) => (
                <div
                  key={row.label}
                  className={row.multiline ? 'sm:col-span-2' : undefined}
                >
                  <div className="text-xs font-semibold uppercase tracking-wide text-indigo-700">
                    {row.label}
                  </div>
                  <div
                    className={`mt-1 text-sm text-gray-900 ${
                      row.multiline ? 'whitespace-pre-wrap' : 'capitalize'
                    }`}
                  >
                    {row.value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : qualifications ? (
          <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
            <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">
              Training completed
            </div>
            <p className="mt-2 whitespace-pre-wrap text-sm text-gray-800">
              {qualifications}
            </p>
          </div>
        ) : (
          <p className="text-sm text-gray-700">
            No structured pathway details were stored.
          </p>
        )}

        {preferences?.source_page ? (
          <Link
            href={`https://cosmetic.college${preferences.source_page}`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center text-sm font-medium text-indigo-700 hover:text-indigo-800"
          >
            Open pathway selector page
            <ArrowTopRightOnSquareIcon className="ml-1 h-4 w-4" />
          </Link>
        ) : null}
      </dd>
    </div>
  );
}
